export default "__VITE_ASSET__CigZopL2__"